export function getOpenBetMessage(action, bet, betType) {

    let messageBar = {
        action: action,
        bet: bet
    };

    return messageBar;
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/helpers/messageBarHelper.js